import { PropsWithChildren } from 'react';

import ErrorPage from '#/components/common/ErrorPage';
import ErrorBoundary from '#/components/common/ErrorBoundary';

const errorPage = (
  <ErrorPage>
    The app just crashed.
    <br />
    Please refresh the page.
  </ErrorPage>
);

export default function TopLevelErrorBoundary(props: PropsWithChildren) {
  return <ErrorBoundary fallback={errorPage}>{props.children}</ErrorBoundary>;
}
